export const getAreas = async () => {
  try {
    const res = await fetch(`/api/all-areas`);
    const json = await res.json();
    // console.log(json);
    return json;
  } catch (error) {
    console.error(error);
  }
};
export const updateArea = async (id, updatedArea) => {
  try {
    const options = {
      method: "PUT",
      body: JSON.stringify({ updatedArea }),
      headers: { "Content-Type": "application/json" },
    };
    const res = await fetch(`/api/area/${id}`, options);
    const json = await res.json();
    // console.log(json);
    return json;
  } catch (error) {
    console.error(error);
  }
};
